export const getImages = requireContext => {
    const images = {};
    requireContext.keys().forEach(key => {
        const filename = key.match(/([^\/]+)(?=\.\w+$)/)[0];
        images[filename] = requireContext(key);
    });
    return images;
};



// WEBPACK FOOTER //
// ./src/Utils/FlavourUtils.js